import { FC, useRef } from 'react';
import Constraints from 'src/shared-components/Constraints/Constraints';
import cn from 'classnames';
import { containerWithBackgroundImageStyle } from 'src/styles/shared';
import { FormattedMessage } from 'react-intl';
import { GetLettersResponse } from 'src/api/requests/getLetters';
import useMedia from 'src/hooks/useMedia';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import useSSRMultyLevelCategoriesStore from 'src/hooks/useSSRMultyLevelCategoriesStore';
import CategoryPlate from './CategoryPlate';
import trns from './trns';
import SearchInputV2 from '../../../../shared-components/SearchInput/SearchInputV2';
import SearchInput from '../../../../shared-components/SearchInput/SearchInput';

interface Props {
  lettersList: GetLettersResponse[];
}

export const HOME_INPUT_ID = 'home-component-id';

const CategoryPlatesContainer: FC<Props> = () => {
  const { multyLevelCategoriesList } = useSSRMultyLevelCategoriesStore();
  const inputRef = useRef<HTMLDivElement>(null);
  const { s, m } = useMedia();

  return (
    <div style={containerWithBackgroundImageStyle} className={'flex w-full'}>
      <div className="w-full">
        <div className="flex-col m:flex m:w-full m:justify-between">
          <div className="compendium-background-blue">
            <Constraints className="w-full flex m:hidden px-10 pt-12">
              <div className="text-astronautBlue fs-header5-bold uppercase text-center">
                <FormattedMessage {...trns.comfortableSearchLabel} />
              </div>
            </Constraints>
          </div>
          <div className="flex flex-col w-full m:items-center compendium-background-blue">
            <Constraints className="w-full">
              <div className="w-full z-10 px-10 m:w-3/5 my-0 mx-auto">
                <div className="hidden m:flex text-astronautBlue fs-header3-bold uppercase text-center m:mt-12">
                  <FormattedMessage {...trns.comfortableSearchLabel} />
                </div>
                <div className="flex flex-col">
                  <div
                    ref={inputRef}
                    className="flex relative h-[50px] mb-10 mt-12 m:mt-9"
                  >
                    {s ? (
                      <SearchInputV2
                        parentRef={inputRef}
                        inputId={HOME_INPUT_ID}
                        withShadowBackground={false}
                        gtagPrefix={GTAGPrefix.speedsearch}
                        fixedModalPosition={true}
                        modalContainerClassName={
                          'shadow-sm mt-[4px] rounded-xl'
                        }
                        dataCy="home-search-input-v2-desktop"
                      />
                    ) : (
                      <SearchInput withIcon={!m} />
                    )}
                  </div>
                </div>
              </div>
            </Constraints>
          </div>
          <Constraints>
            <div
              className={cn(
                'grid grid-cols-3 gap-1.5 px-7.5 mt-11',
                'm:flex m:justify-between m:flex-wrap m:mt-11'
              )}
            >
              {multyLevelCategoriesList?.map((category) => {
                return (
                  <CategoryPlate
                    key={category.translitName}
                    category={category}
                  />
                );
              })}
            </div>
          </Constraints>
        </div>
      </div>
    </div>
  );
};

export default CategoryPlatesContainer;
